import api from './api';

const alipayService = {
  getStatus: async () => {
    const response = await api.get('/alipay/status');
    return response.data;
  },

  getAuthUrl: async () => {
    const response = await api.get('/alipay/auth-url');
    return response.data.authUrl;
  },

  bindWithCode: async (authCode) => {
    const response = await api.post('/alipay/bindWithCode', { authCode });
    return response.data;
  },

  unbind: async () => {
    const response = await api.delete('/alipay/bindStatus');
    return response.data;
  },

  syncBills: async (startDate, endDate) => {
    const response = await api.post('/alipay/sync', { startDate, endDate });
    return response.data;
  },
};

export default alipayService;
